import type { IconData } from '@stacksjs/iconify-core'

export const naturePlant: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1 0a7 7 0 0 1 7 7a7 7 0 0 1 7-7v9A7 7 0 1 1 1 9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default naturePlant
